import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";
import { FaCopy, FaFire, FaBolt } from "react-icons/fa";
import { GiGamepad } from "react-icons/gi";
import { useNavigate } from "react-router-dom";
import { fetchActiveDiscounts } from "../Redux/Slice/discount.slice";
import { getAllActiveGames } from "../Redux/Slice/game.slice";
import toast from "react-hot-toast";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

/* ─── Dummy Image dataset for initial load ─── */
const DUMMY_COVERS = [
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1777371311142-ffight1.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757066297683-Kqw6BrsOlCktEKwZP5SNODAXr29LrzaMx8OJUkXjqMCwqHPfTFxVM5_Q2lprxOtAZ2txYG81KtoQXZuMiEpTVnruvADuS4H6LFR-3miA3_-llChsCybqxw7OFVhILPJJvyxzTxhIBXXKRU3GcJS31rl1rv-yPyOPEISOU5pZFgjqcGpbco2XqW7Y7IO610jgu5qkZIvprUMGz.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757066155730-duolingo-2048x1152.png",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1777458183323-21.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757069803089-1280.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757069569407-EGS_TheLongDark_HinterlandStudioInc_S5-1920x1080-fcfdd407ac1990bec320b49101862585.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757068973789-croppedimage1201631-dontstarve-610-zpsb8fa8582.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1777457186220-download.jfif",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1777463737298-riya1.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1781087804140-screen-5.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757478748108-fgfs-few-.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757067263649-banner.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757065877897-1920.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757054610010-62c795bc5e2895b39563566b09ae39fd_fgraphic.png",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1777523702929-merge-farm.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757061146680-ea9c950efa.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1756168919617-valor-banner.png",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1777290520275-1.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757056191170-orig(2).webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757055254785-tablica-dlja-cheat-engine-upd-24-09-2024_1727343774_949054.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1777352658101-unnamed.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1777455057029-i.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757478866839-maxresdefault(2).jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757051724517-DljxEq4V-bU.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757051454899-19d264bbfc0eed00951f1f9c8bc0d18d.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757050776104-Share_Image_1920x1080_1920x1080-3ec6b92b109d6ebe190c7fd8da23b989.png",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757050347269-screen-17.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757049411761-6de0fcea1996bc78c1b27bfd970feca6.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757055813847-caves-of-qud-rpg.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757065945831-1200x630wa.png",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1777525649566-cover19.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757333006146-56725b20666bf54b8e6d1c369e701b4b.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1777463332731-unnamed(5).webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1777271329522-cover.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1756167015177-silent-marksman-banner.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757066271357-maxresdefault(11).jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757066103058-7BivlX6DZFwWIVZ52KHSSQ.jpeg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757397570536-maxresdefault(6).jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757064060542-cd775a27-63c2-4e40-831d-7908c5864348.jpeg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1756168117465-mario-banner.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757057183672-c52a787b7790ca66c4ae9710d3d30e31.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1756123879611-dayz-og-thumb.png",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1756124276384-unnamed(1).webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1776938727970-maxresdefault(11).webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757055554629-orig(1).webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1777366297059-Dark_fantasy_side-scrolling_202604281415.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757054991671-inside.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1777273851486-cover4.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1777272474701-cover1.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1756986363333-unnamed(91).webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757052406734-Ni-No-Kuni-Wrath-Of-The-White-Witch-Switch.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757051468099-maxresdefault(2).jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757050519234-reaper-tale-of-a-pale-swordsman-0.png",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757050179664-unnamed.png",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757046240962-deity-quest-preview.png",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1777526814700-baby.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1756986231644-featured_com.wood.nut.and.bolts.puzzle.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757055916149-zoombinis.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1756986139160-113764772(1).webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757479084546-maxresdefault(3).jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1756119871228-Celeste.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757068690550-6425598109.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1777288266992-11.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1777525529628-Demon-Hunter-Idle-cover.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757062737710-RCRA_Header_Wide.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757061935135-unnamed(3).png",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757057522592-Enshrouded-easysmx-controller.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757057410183-3022OY.png",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757055924249-games-like-rainbow-six-siege.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757054337712-maxresdefault(3).jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757054860832-maxresdefault(5).jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1756986508636-unnamed(92).webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757053127078-coin-clicker-cover.png",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757477941794-fbdbbf5f0fff0345276fb30c526837fa.jpeg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757052671926-Pr0tM4q8KPIOttIyHoq6xei1-2048x1152.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757051942184-unnamed(1).png",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757049911046-Poinpy.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757049733137-2c40ebc1b6589f35c956d7a20d0488bc-1536x864.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1777273225198-cover2.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757477436119-Little_Kingdom_RTS.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757049150348-339550-mb4hfkpz-v4.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757062202518-screen-5(2).jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1777455474880-maxresdefault.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1777460430545-download.jfif",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1777353368812-Troy-Burrows_SO_RedRngS21_S21_social1920x1080.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1756122961230-hunt-showdown-pc-game-steam-cover.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757063376731-EGS_FellSealArbitersMarkMissionsandMonsters_6EyesStudio_DLC_S1-2560x1440-ab1c53e9caca963094f9f5b491e660a4.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757073205189-crayon_physics_deluxe-hero.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757062500364-ghost-tsushima.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1777522609847-pocket_tales_survival_game_cover.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1777008389540-i(21).webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1756169399688-tr-banner.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1777458854852-maxresdefault.webp",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757054800296-maxresdefault(4).jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757045255787-maxresdefault.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757055645140-4d984f8c4ff310af1706690fce28eb51199283f5.png",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757055236555-unnamed(4).png",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757054986788-unnamed(4).jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757479917391-maxresdefault(4).jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757305347170-logo.jpg",
  "https://yoyo-game.s3.ap-south-1.amazonaws.com/GameCoverImage/1757056310691-wallpapersden.com_tactics-ogre-reborn-gaming-hd_1920x1080.jpg"
];

const DUMMY_BANNER = {
  _id: "dummy_loading_banner",
  discountType: "game",
  discountValue: 50,
  title: "Loading Epic Deals...",
  subtitle: "Please wait while we fetch the latest discounts",
  startDate: null,
  endDate: null,
  gameIds: DUMMY_COVERS.map((url, index) => ({
    _id: `dummy_game_${index}`,
    title: `Dummy Game ${index}`,
    cover_image: { url }
  }))
};

/* ─── Accent config per discount type ─── */
const TYPE_CONFIG = {
  game: { primary: "#a855f7", secondary: "#ec4899", glow: "rgba(168,85,247,0.6)", label: "GAME DEALS" },
  category: { primary: "#06b6d4", secondary: "#3b82f6", glow: "rgba(6,182,212,0.6)", label: "CATEGORY DEALS" },
  top_download: { primary: "#f59e0b", secondary: "#ef4444", glow: "rgba(245,158,11,0.6)", label: "TOP HITS" },
  promocode: { primary: "#10b981", secondary: "#06b6d4", glow: "rgba(16,185,129,0.6)", label: "PROMO CODE" },
};

/* ─── Live Countdown Hook ─── */
const useCountdown = (startDate, endDate) => {
  const [timeLeft, setTimeLeft] = useState(0);
  const [status, setStatus] = useState("always"); // "upcoming" | "running" | "ended" | "always"

  useEffect(() => {
    if (!startDate && !endDate) {
      setStatus("always");
      setTimeLeft(0);
      return;
    }

    const calculateTime = () => {
      const now = new Date().getTime();
      const start = startDate ? new Date(startDate).getTime() : 0;
      const end = endDate ? new Date(endDate).getTime() : 0;

      if (start && now < start) {
        setStatus("upcoming");
        setTimeLeft(start - now);
      } else if (end && now < end) {
        setStatus("running");
        setTimeLeft(end - now);
      } else {
        setStatus("ended");
        setTimeLeft(0);
      }
    };

    calculateTime();
    const interval = setInterval(calculateTime, 1000);
    return () => clearInterval(interval);
  }, [startDate, endDate]);

  return { timeLeft, status };
};

/* ─── Collage Image component with loading transition ─── */
const CollageImage = React.memo(({ src }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!src) return;
    const img = new Image();
    img.src = src;

    const handleLoad = () => setLoaded(true);
    img.onload = handleLoad;
    img.onerror = handleLoad;

    if (img.complete) {
      setLoaded(true);
    }

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [src]);

  return (
    <div className="relative w-full h-auto aspect-[130/175] mb-2 flex-shrink-0 rounded-xl border-[2px] border-[#101017] shadow-[0_8px_20px_rgba(0,0,0,0.6)] overflow-hidden bg-[#09090e]">
      {/* Pulse loading skeleton */}
      <div
        className={`absolute inset-0 bg-white/[0.04] transition-opacity duration-500 pointer-events-none ${loaded ? "opacity-0" : "opacity-100 animate-pulse"
          }`}
      />

      {src && (
        <img
          src={src}
          alt=""
          className={`w-full h-full object-cover rounded-xl transition-all duration-[750ms] ease-out ${loaded ? "opacity-100 scale-100 blur-0" : "opacity-0 scale-95 blur-md"
            }`}
        />
      )}
    </div>
  );
});

/* ─── Individual slide ─── */
const BannerSlide = React.memo(({ banner, isActive, onBannerClick, onCopyCode }) => {
  const cfg = TYPE_CONFIG[banner.discountType] || TYPE_CONFIG.promocode;
  const { games } = useSelector((s) => s.game);
  const { timeLeft, status } = useCountdown(banner.startDate, banner.endDate);

  // Staggered slanted collage covers from this discount's gameIds or fallback to all active games
  const targetGames = (banner?.gameIds && banner.gameIds.length > 0) ? banner.gameIds : (games || []);
  const collageCovers = targetGames
    .map((g) => g.cover_image?.url)
    .filter(Boolean);

  const col1Covers = [];
  const col2Covers = [];
  const col3Covers = [];
  const col4Covers = [];

  if (collageCovers.length > 0) {
    collageCovers.forEach((url, i) => {
      const colIdx = i % 4;
      if (colIdx === 0) col1Covers.push(url);
      else if (colIdx === 1) col2Covers.push(url);
      else if (colIdx === 2) col3Covers.push(url);
      else col4Covers.push(url);
    });
  }

  // Ensure each column has a minimum number of covers for a smooth scrolling loop
  const ensureMinLength = (arr, min = 6) => {
    if (arr.length === 0) return [];
    let res = [...arr];
    while (res.length < min) {
      res.push(...arr);
    }
    return res;
  };

  const finalCol1 = ensureMinLength(col1Covers);
  const finalCol2 = ensureMinLength(col2Covers);
  const finalCol3 = ensureMinLength(col3Covers);
  const finalCol4 = ensureMinLength(col4Covers);

  // Duplicate for seamless infinite marquee loop
  const col1 = [...finalCol1, ...finalCol1];
  const col2 = [...finalCol2, ...finalCol2];
  const col3 = [...finalCol3, ...finalCol3];
  const col4 = [...finalCol4, ...finalCol4];

  return (
    <div
      className={`relative w-full h-[245px] xs:h-[260px] sm:h-[280px] md600:h-[280px] md:h-[300px] lg:h-[320px] xl:h-[320px] 2xl:h-[350px] 3xl:h-[350px] 4xl:h-[400px] flex items-center overflow-hidden ${banner._id === "dummy_loading_banner" ? "cursor-default" : "cursor-pointer"
        }`}
      onClick={() => {
        if (banner._id !== "dummy_loading_banner") {
          // onBannerClick(banner);
        }
      }}
    >
      {/* ── Background layer ── */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0" style={{
          background: `radial-gradient(circle at 10% 50%, rgba(168,85,247,0.12) 0%, transparent 50%),
                       linear-gradient(135deg, #09090e 0%, #06050b 100%)`
        }} />

        {/* Faint watermark text */}
        <div className="absolute inset-0 flex items-center justify-start pl-[20%] pointer-events-none opacity-[0.04] z-[1] -rotate-[10deg] scale-[1.1] font-black">
          <span className="text-[11rem] text-transparent [-webkit-text-stroke:3px_#ffffff]">{banner?.discountType === "promocode" ? "CODE" : `${banner.discountValue}`}</span>
          <span className="text-[7rem] text-transparent [-webkit-text-stroke:3px_#ffffff] ml-2">{banner?.discountType === "promocode" ? "" : "%"}</span>
          {/* {banner?.discountType === "promocode" ? null : (
            <span className="text-[13rem] text-transparent [-webkit-text-stroke:3px_#ffffff] ml-4">/</span>
          )} */}
        </div>

        {/* Scan-line shimmer */}
        <div className="absolute inset-0 z-[2] pointer-events-none bg-[repeating-linear-gradient(to_bottom,transparent_0px,transparent_3px,rgba(0,0,0,0.06)_4px)]" />
      </div>

      <motion.div
        className="hidden sm:block absolute left-[40%] top-[10%] text-purple-500/10 blur-[1px] pointer-events-none z-[5]"
        animate={{ rotate: [-25, -20, -25], y: [0, -15, 0] }}
        transition={{ duration: 8, ease: "easeInOut", repeat: Infinity }}
      >
        <GiGamepad size={160} />
      </motion.div>

      {/* ── Content ── */}
      <AnimatePresence mode="wait">
        {isActive && (
          <motion.div
            key={banner._id}
            className="relative z-10 w-full  p-4 xs:p-4 sm:p-5 md:p-6 md:pl-10 lg:pl-12 md600:max-w-[55%] md:max-w-[520px] lg:max-w-[560px] xl:max-w-[600px] 2xl:max-w-[680px] flex flex-col gap-1 md600:items-start items-center text-center md600:text-left"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            {/* Badge */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.1, duration: 0.5 }}
              className="inline-flex items-center px-[0.6rem] py-[0.2rem] sm:px-[0.8rem] sm:py-[0.25rem] rounded-full border border-transparent [background:linear-gradient(#09090e,#09090e)_padding-box,linear-gradient(90deg,#5b5df2_0%,#c026d3_100%)_border-box] text-[0.5rem] sm:text-[0.55rem] md:text-[0.62rem] font-extrabold tracking-[0.1em] uppercase w-fit text-white shadow-[0_0_15px_rgba(91,93,242,0.15)]"
            >
              <span>{cfg.label}</span>
            </motion.div>

            {/* Custom Outline Design */}
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.15, duration: 0.6, type: "spring", stiffness: 180 }}
              className="flex items-center gap-2 leading-none"
            >
              <div className="relative flex items-center select-none">
                {/* 3D Embossed Gradient Chakra Petch Text */}
                <span
                  className="embossed-3d-gradient text-[2.4rem] xs:text-[2.8rem] sm:text-[3.2rem] md:text-[3.8rem] lg:text-[4.4rem] xl:text-[5rem] tracking-[0.02em] leading-none"
                  data-text={`${banner.discountValue}%`}
                >
                  {banner.discountValue}%
                </span>

                {/* SVG Tag Icon */}
                {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="absolute -top-1 -right-5.5 rotate-[50deg] w-[1.35rem] h-[1.35rem] drop-shadow-[0_0_6px_rgba(236,72,153,0.5)]">
                  <defs>
                    <linearGradient id="tagGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="#6263ED" />
                      <stop offset="100%" stopColor="#A7006F" />
                    </linearGradient>
                  </defs>
                  <path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42z" fill="url(#tagGrad)" />
                  <circle cx="6.5" cy="6.5" r="1.5" fill="#09090e" />
                  <text x="12" y="15" fill="#09090e" fontSize="7" fontWeight="bold" fontFamily="sans-serif" textAnchor="middle" transform="rotate(-45 12 15)">%</text>
                </svg> */}
              </div>

              <div className="flex items-center ml-1">
                <span className="embossed-3d-white-small text-[1.4rem] xs:text-[1.6rem] sm:text-[1.9rem] md:text-[2.2rem] lg:text-[2.7rem] xl:text-[3rem] uppercase select-none tracking-[0.05em] leading-none">
                  off
                </span>
              </div>
            </motion.div>

            {/* Title */}
            <motion.h2
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.25, duration: 0.5 }}
              className="text-[0.72rem] xs:text-[0.78rem] sm:text-[0.88rem] md:text-[1rem] lg:text-[1.15rem] xl:text-[1.3rem] font-black text-white m-0 tracking-tight"
            >
              {banner.title} •
            </motion.h2>

            {/* Subtitle */}
            <motion.p
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.5 }}
              className="text-[0.62rem] xs:text-[0.66rem] sm:text-[0.72rem] md:text-[0.8rem] lg:text-[0.88rem] font-medium m-0 italic text-white/80 font-serif hidden xs:block"
            >
              {banner.subtitle || "Limited time deal"}
            </motion.p>

            {/* Campaign Duration Countdown Timer */}
            {(banner.startDate || banner.endDate) && (
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.35 }}
                className="mt-1 mb-1"
              >
                {status === "ended" ? (
                  <div className="text-[0.72rem] font-extrabold text-red-500 bg-red-500/10 border border-red-500/20 px-3 py-1 rounded-md tracking-[0.05em] w-fit">
                    <span>DEAL ENDED</span>
                  </div>
                ) : (
                  (() => {
                    const seconds = Math.floor((timeLeft / 1000) % 60);
                    const minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
                    const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
                    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));

                    const pad = (num) => String(num).padStart(2, "0");
                    const label = status === "upcoming" ? "DEAL STARTS IN:" : "DEAL ENDS IN:";
                    const isEndingSoon = status === "running" && timeLeft < 24 * 60 * 60 * 1000;

                    return (
                      <div className={`flex flex-col gap-1.5 w-fit sm:items-start items-center ${isEndingSoon ? "animate-pulse" : ""}`}>
                        <div className="flex items-center gap-1.5">
                          {status === "running" ? (
                            <FaFire className="text-[0.85rem] text-[#f43f5e] drop-shadow-[0_0_5px_rgba(244,63,94,0.6)] animate-pulse" />
                          ) : (
                            <FaBolt className="text-[0.85rem] text-[#f59e0b] drop-shadow-[0_0_5px_rgba(245,158,11,0.6)]" />
                          )}
                          <span className="text-[0.72rem] font-bold text-white/60 tracking-[0.08em] uppercase">{label}</span>
                        </div>
                        <div className="flex items-center gap-1">
                          {days > 0 && (
                            <>
                              <div className="bg-white/[0.04] border border-white/[0.08] rounded-md px-2 py-0.5 flex items-baseline gap-0.5 shadow-[inset_0_1px_1px_rgba(255,255,255,0.05)]">
                                <span className="font-mono text-[0.95rem] font-extrabold text-white">{pad(days)}</span>
                                <span className="text-[0.62rem] font-semibold text-white/40 lowercase">d</span>
                              </div>
                              <span className="text-[0.9rem] font-bold text-white/25 animate-pulse">:</span>
                            </>
                          )}
                          <div className="bg-white/[0.04] border border-white/[0.08] rounded-md px-2 py-0.5 flex items-baseline gap-0.5 shadow-[inset_0_1px_1px_rgba(255,255,255,0.05)]">
                            <span className="font-mono text-[0.95rem] font-extrabold text-white">{pad(hours)}</span>
                            <span className="text-[0.62rem] font-semibold text-white/40 lowercase">h</span>
                          </div>
                          <span className="text-[0.9rem] font-bold text-white/25 animate-pulse">:</span>
                          <div className="bg-white/[0.04] border border-white/[0.08] rounded-md px-2 py-0.5 flex items-baseline gap-0.5 shadow-[inset_0_1px_1px_rgba(255,255,255,0.05)]">
                            <span className="font-mono text-[0.95rem] font-extrabold text-white">{pad(minutes)}</span>
                            <span className="text-[0.62rem] font-semibold text-white/40 lowercase">m</span>
                          </div>
                          <span className="text-[0.9rem] font-bold text-white/25 animate-pulse">:</span>
                          <div className="bg-white/[0.04] border border-white/[0.08] rounded-md px-2 py-0.5 flex items-baseline gap-0.5 shadow-[inset_0_1px_1px_rgba(255,255,255,0.05)]">
                            <span className="font-mono text-[0.95rem] font-extrabold text-[#d946ef] [text-shadow:0_0_5px_rgba(217,70,239,0.5)]">{pad(seconds)}</span>
                            <span className="text-[0.62rem] font-semibold text-white/40 lowercase">s</span>
                          </div>
                        </div>
                      </div>
                    );
                  })()
                )}
              </motion.div>
            )}

            {/* Promo code chip */}
            {banner.discountType === "promocode" && banner.promoCode && (
              <motion.div
                initial={{ opacity: 0, scale: 0.85 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.38 }}
                className="mt-2"
              >
                <button
                  onClick={(e) => onCopyCode(e, banner.promoCode)}
                  className="inline-flex items-center gap-2 px-[1.2rem] py-[0.5rem] rounded-xl cursor-copy transition-all hover:scale-105 active:scale-95 font-mono text-[0.9rem] font-extrabold tracking-[0.12em] uppercase"
                  style={{
                    background: cfg.primary + "22",
                    border: `1.5px solid ${cfg.primary}80`,
                    color: cfg.primary,
                    boxShadow: `0 0 20px ${cfg.primary}30`,
                  }}
                >
                  <span>{banner.promoCode}</span>
                  <FaCopy style={{ fontSize: "0.75rem", opacity: 0.8 }} />
                  <span className="text-[0.6rem] font-bold tracking-[0.2em] opacity-70 font-sans">COPY</span>
                </button>
              </motion.div>
            )}

            {/* Redesigned Button CTA */}
            <motion.div
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              className="flex sm:justify-start justify-center w-full sm:w-auto"
            >
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  if (banner._id !== "dummy_loading_banner") {
                    onBannerClick(banner);
                  }
                }}
                className={`bg-gradient-to-r from-[#5b5df2] to-[#c026d3] text-white font-medium text-[0.8rem] px-6 py-2.5 rounded-md shadow-[0_4px_15px_rgba(91,92,242,0.3)] transition-all w-fit border-none mt-1.5 ${banner._id === "dummy_loading_banner"
                  ? "opacity-50 cursor-default"
                  : "hover:translate-y-[-2px] hover:shadow-[0_6px_22px_rgba(192,38,211,0.45)] cursor-pointer"
                  }`}
              >
                View All Deals
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      {/* ── Right side: Slanted Grid Collage ── */}
      {col1.length > 0 && (
        <motion.div
          className="absolute right-0 -top-[20%] w-[52%] h-[140%] pointer-events-none z-[5] xs:w-[54%] sm:w-[58%] md600:w-[56%] md:w-[56%] lg:w-[56%] xl:w-[58%] 2xl:w-[60%] 3xl:w-[62%] 4xl:w-[60%]"
          style={{ right: "-4%" }}
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          {/* Black overlay — only on sm (425px) and below for text readability */}
          <div
            className="absolute inset-0 z-[6] pointer-events-none sm:hidden"
            style={{
              background: "linear-gradient(to right, rgba(9,9,14,0.92) 0%, rgba(9,9,14,0.55) 45%, rgba(9,9,14,0.0) 100%)"
            }}
          />

          <div
            className="flex justify-end  2xl:pr-10 3xl:pr-28 gap-2 md:gap-3 w-full h-full"
            style={{
              transform: "rotate(20deg) translateY(3%) scale(1.30)",
              maskImage: "linear-gradient(to right, transparent 0%, black 20%), linear-gradient(to bottom, transparent 0%, black 8%, black 92%, transparent 100%)",
              WebkitMaskImage: "linear-gradient(to right, transparent 0%, black 20%), linear-gradient(to bottom, transparent 0%, black 8%, black 92%, transparent 100%)",
              maskComposite: "intersect",
              WebkitMaskComposite: "source-in",
              opacity: 0.9,
            }}
          >

            {/* Col 1 — always visible at all screen sizes */}
            <div className=" flex-col flex-shrink-0 overflow-hidden hidden lg:flex h-full w-[80px] xs:w-[88px] sm:w-[95px] md600:w-[100px] md:w-[108px] lg:w-[118px] xl:w-[132px] 2xl:w-[142px] 3xl:w-[155px] 4xl:w-[175px]">
              <motion.div
                className="flex flex-col w-full"
                animate={{ y: ["0%", "-50%"] }}
                transition={{ ease: "linear", duration: 300, repeat: Infinity }}
              >
                {col1.map((url, i) => (
                  <CollageImage key={`col1-${i}`} src={url} />
                ))}
              </motion.div>
            </div>

            {/* Col 2 — always visible at all screen sizes */}
            <div className=" flex-col flex-shrink-0 overflow-hidden hidden md600:flex h-full w-[80px] xs:w-[88px] sm:w-[95px] md600:w-[100px] md:w-[108px] lg:w-[118px] xl:w-[132px] 2xl:w-[142px] 3xl:w-[155px] 4xl:w-[175px]">
              <motion.div
                className="flex flex-col w-full"
                animate={{ y: ["-50%", "0%"] }}
                transition={{ ease: "linear", duration: 260, repeat: Infinity }}
              >
                {col2.map((url, i) => (
                  <CollageImage key={`col2-${i}`} src={url} />
                ))}
              </motion.div>
            </div>

            {/* Col 3 — hidden on sm (425px) and below, visible from md600+ */}
            <div className="hidden md600:flex flex-col flex-shrink-0 overflow-hidden h-full md600:w-[100px] md:w-[108px] lg:w-[118px] xl:w-[132px] 2xl:w-[142px] 3xl:w-[155px] 4xl:w-[175px]">
              <motion.div
                className="flex flex-col w-full"
                animate={{ y: ["0%", "-50%"] }}
                transition={{ ease: "linear", duration: 340, repeat: Infinity }}
              >
                {col3.map((url, i) => (
                  <CollageImage key={`col3-${i}`} src={url} />
                ))}
              </motion.div>
            </div>

            {/* Col 4 — hidden below lg (1024px), visible lg and above */}
            <div className="hidden xxl:flex flex-col flex-shrink-0 overflow-hidden h-full lg:w-[118px] xl:w-[132px] 2xl:w-[145px] 3xl:w-[155px] 4xl:w-[175px]">
              <motion.div
                className="flex flex-col w-full"
                animate={{ y: ["-50%", "0%"] }}
                transition={{ ease: "linear", duration: 290, repeat: Infinity }}
              >
                {col4.map((url, i) => (
                  <CollageImage key={`col4-${i}`} src={url} />
                ))}
              </motion.div>
            </div>

          </div>
        </motion.div>
      )}
    </div>
  );
});

/* ─── Main component ─── */
const DiscountBanner = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { activeDiscounts, loading } = useSelector((s) => s.discount);
  const { games } = useSelector((s) => s.game);
  const [activeIdx, setActiveIdx] = useState(0);
  const timerRef = useRef(null);

  // Local state initialized with the DUMMY_BANNER to render immediately
  const [banners, setBanners] = useState([DUMMY_BANNER]);

  useEffect(() => {
    dispatch(fetchActiveDiscounts());
    dispatch(getAllActiveGames());
  }, [dispatch]);

  // Preload dummy covers on mount to render immediately and smoothly
  useEffect(() => {
    DUMMY_COVERS.forEach((url) => {
      const img = new Image();
      img.src = url;
    });
  }, []);

  // Update banners state when database data becomes available
  useEffect(() => {
    const fetched = activeDiscounts.filter((d) => d.isActive).slice(0, 5);
    if (!loading && fetched.length > 0) {
      setBanners(fetched);
    }
  }, [activeDiscounts, loading]);

  // Preload all banner cover images in the background once fetched from the database
  useEffect(() => {
    if (banners && banners.length > 0 && banners[0]._id !== "dummy_loading_banner") {
      const urlsToPreload = new Set();

      banners.forEach((banner) => {
        const targetGames = (banner?.gameIds && banner.gameIds.length > 0)
          ? banner.gameIds
          : (games || []);

        targetGames.forEach((g) => {
          if (g.cover_image?.url) {
            urlsToPreload.add(g.cover_image.url);
          }
        });
      });

      // Programmatically trigger preloading of the gathered urls
      urlsToPreload.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }, [banners, games]);

  /* Auto-advance every 5 s */
  const startTimer = useCallback(() => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setActiveIdx((i) => (i + 1) % banners.length);
    }, 5000);
  }, [banners.length]);

  useEffect(() => {
    if (banners.length > 1) startTimer();
    return () => clearInterval(timerRef.current);
  }, [banners.length, startTimer]);

  const goTo = (i) => { setActiveIdx(i); startTimer(); };

  const handleBannerClick = (banner) => {
    navigate(`/discount/${banner._id}/games`);
  };

  const handleCopyCode = (e, code) => {
    e.stopPropagation();
    navigator.clipboard?.writeText(code).then(() =>
      toast.success(`Code "${code}" copied!`)
    );
  };

  // Only return null if not loading and there are no active discounts to display
  if (!loading && activeDiscounts.filter((d) => d.isActive).length === 0) return null;

  const activeBanner = banners[activeIdx];
  const cfg = TYPE_CONFIG[activeBanner?.discountType] || TYPE_CONFIG.promocode;

  return (
    <>
      {/* ─── Banner wrapper ─── */}
      <div className="mx-auto w-full max-w-[100%] md:max-w-[90%] xl:max-w-[80%] px-4 mt-16 lg:mt-24 lg:mb-20 mb-10 ">
        <div
          className="w-full relative overflow-hidden bg-[#09090e] rounded-[2rem] banner-highlight-glow"
          style={{
            "--glow-color-primary": cfg.primary,
            "--glow-color-secondary": cfg.secondary,
            "--glow-shadow": cfg.glow
          }}
        >
          {/* Slides */}
          <div style={{ position: "relative" }}>
            <AnimatePresence mode="wait">
              <motion.div
                key={activeIdx}
                initial={{ opacity: 0, x: 60 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -60 }}
                transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
              >
                <BannerSlide
                  banner={activeBanner}
                  isActive={true}
                  onBannerClick={handleBannerClick}
                  onCopyCode={handleCopyCode}
                />
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Dot nav */}
          {banners.length > 1 && (
            <div className="flex items-center justify-center gap-2 py-3 bg-black/35 backdrop-blur-md">
              {banners.map((_, i) => (
                <button
                  key={i}
                  className="h-2 rounded-full border-none p-0 cursor-pointer transition-all duration-[350ms] ease-in-out"
                  style={{
                    width: i === activeIdx ? "28px" : "8px",
                    backgroundColor: i === activeIdx ? cfg.primary : "rgba(255, 255, 255, 0.25)",
                    boxShadow: i === activeIdx ? `0 0 12px ${cfg.primary}` : "none",
                  }}
                  onClick={() => goTo(i)}
                  aria-label={`Go to slide ${i + 1}`}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DiscountBanner;
